import PropTypes from 'prop-types';
import React from 'react';
import { ArrayInput as ReactAdminArrayInput, required as requiredFn } from 'react-admin';

export const ArrayInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminArrayInput
    {...props}
    validate={isRequired ? requiredFn() : validate}
  />
)

ArrayInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

ArrayInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true
};

export default ArrayInput;

